export { default as InputLeftElement } from './InputLeftElement'
